import React from 'react'
import Layout from '../components/layout'
import Nav from '../components/nav'
// import Event from '../components/event'


import Banner from '../components/non-front-banner'
// import AuthorImg from '../../static/author/author-profile.jpg'
import DummyImg from '../../static/author/author.png'
import { Helmet } from "react-helmet"

const ATB = (props) => {

    return (
        <>
            <Layout>
                <Helmet title="About the Author | Doris Howe" />
                <Nav pathExt={props.path} />

                <Banner
                    spanFirst={`About The`}
                    contextHeading={`Author`} />

                <div className="container">
                    <section className="body-author-contents columns">
                        <div className="heading-quote column">
                            <div className="author-image-container">
                                <img
                                    src={DummyImg}
                                    alt="_main_author" />
                            </div>

                            <div className="heading-quote">
                                <h4>
                                “…it’s just like our adoption into the Family of GOD.”

                                </h4>
                               
                            </div>
                        </div>

                        
                        <article className="article-section column" id="author">

                        <p>
                        My interest in writing began when I had an excellent high school English Teacher. Diagramming sentences  was like solving mysteries.</p>  
                        
                        <p>After college I taught English to jr. high students where I had them create and write weekly. As an adoption caseworker for over 20 years,  true stories accumulated for me and begged to be shared.
                            </p> 
                            
                         <p>Hence ADOPTIN JOYS, They Expected A Miracle, and most recently, ADOPTION JOYS Book 2, Dads Make A Difference.</p>

                            <p>
                                <span className="author-name">
                                    <span className="author-span-ft">Author | Writer </span>
                                    <span className="ata-name">Doris Howe</span>
                                </span>
                            </p> 

                        </article>
                    </section>
                </div>

                {/* <Event /> */}
                

            </Layout>
        </>
    )
}


export default ATB;
